import './reviews.component.scss'

import 'holy-stars/index.css'
import HolyStars from 'holy-stars'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import Swiper, { Navigation, Pagination } from 'swiper'

class ReviewsSlider {
  constructor(elements) {
		this.elements = elements
		this.sliderInstance = null

    this.init()
  }

  defineSlider() {
    this.sliderInstance = new Swiper(this.elements.slider, {
      modules: [Navigation, Pagination],
      spaceBetween: 32,
      autoHeight: true,
      pagination: {
        el: this.elements.pagination,
        type: 'bullets',
        clickable: true
      },
      navigation: this.elements.navigation,
    })
  }

  init() {
    this.defineSlider()
	}

	updateSwiper() {
    if (this.sliderInstance) {
      this.sliderInstance.update()
    }
  }
}

const reviewSectionEl = document.querySelector('.reviews')
if (reviewSectionEl) {
  const navigation = {
    prevEl: reviewSectionEl.querySelector('.reviews__arrow_prev'),
    nextEl: reviewSectionEl.querySelector('.reviews__arrow_next'),
  }

  const pagination = reviewSectionEl.querySelector('.swiper-pagination')

  const slider = reviewSectionEl.querySelector('.swiper')

  const rateItems = slider.querySelectorAll('.review-card__rate')

  rateItems.forEach(item => {
    const num = +item.textContent
    new HolyStars({
      el: item,
      rate: +num,
      size: 16,
      primaryColor: '#FFCC18',
      secondColor: '#dadada'
    })
  })

  if (slider) {
    const reviewsSlider = new ReviewsSlider({
      slider,
      pagination,
      navigation
		})

		function getTextMetrics(element) {
			const computedStyle = window.getComputedStyle(element)
			const lineHeight = parseFloat(computedStyle.lineHeight)
			const elementHeight = element.clientHeight
			const numberOfLines = Math.floor(elementHeight / lineHeight)

			return {
				numberOfLines,
			}
		}

		const sliderItem = slider.querySelectorAll('.reviews-slider__item')
		sliderItem.forEach(item => {
			const reviewText = item.querySelector('.review-card__text')
			const lines = getTextMetrics(reviewText).numberOfLines

			if (lines > 4) {
				reviewText.classList.add('js-long-text', 'js-long-text-clamp')

				const readMoreButton = document.createElement('span')
        readMoreButton.textContent = 'Read More'
				readMoreButton.classList.add('read-more-btn')

				readMoreButton.addEventListener('click', function() {
					reviewText.classList.toggle('js-show')
					if (reviewText.classList.contains('js-show')) {
						readMoreButton.textContent = 'Show Less'
						reviewText.classList.remove('js-long-text-clamp')
					} else {
						readMoreButton.textContent = 'Read More'
						reviewText.classList.add('js-long-text-clamp')
					}
					reviewsSlider.updateSwiper()
				})

				reviewText.appendChild(readMoreButton)
			}
		})
  }
}
